module.exports = ".active {\n    border-left: 3px solid #fb625c;\n}\n.chart-label{\n    padding: 0 5px;\n    font-size: 11px;\n}\n.chart-img{\n    width: 2.5em;\n    padding: 5px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-list/sst-graph-list.component.css
// module id = ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-list/sst-graph-list.component.css
// module chunks = main